import { assemble } from 'public/elements.js';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Grid } from '@splidejs/splide-extension-grid';
import { Video } from '@splidejs/splide-extension-video';

(function () {
    // Check if the YouTube API script is already present
    if (!document.getElementById('youtube-api')) {
        let tag = document.createElement('script');
        tag.id = "youtube-api"; // Assign an ID to the script element for future reference
        tag.src = "https://www.youtube.com/iframe_api"; // Set the source to the YouTube IFrame API
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    if (!window.checkReady) {
        window.checkReady = new Promise((resolve) => {
            if (window.YT && window.YT.loaded) {
                console.log('slider YT loaded');
                resolve(window.YT)
            } else {
                window.onYouTubeIframeAPIReady = () => {
                    resolve(window.YT);
                };
            }
        });
    }
})();

class YoutubePlayerSlider extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.splide = null;
        this.splideID = 'slider-' + Math.random().toString(36).substr(2, 9);
        this.is_init = null;
        this.index = 0;
        this.playerID;
        this.error;
    }

    connectedCallback() {
        //console.log("VERSION _ 1042");
        this.pre_init();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "settings") {
            this.pre_init()
        }
    }
    pre_init() {
        this.props = JSON.parse(this.getAttribute('settings'));
        //console.log(this.props);
        if (this.is_init && this.props) return ('was init, skip initialization');

        this.is_init = true;

        window.checkReady.then(() => {
            console.log('slider loaded')
            this.get_videos();
        });

    }
    generateRandomId(length = 8) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = 'id_';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }
    get_videos() {
        if (!this.props) return console.error('no props');
        if (this.player && this.playerID) {
            while (this.shadowRoot.firstChild) {
                this.shadowRoot.removeChild(this.shadowRoot.firstChild);
            }
        }
        if(this.props.playerProps.list && this.index === 0){
            const storedData = sessionStorage.getItem(this.props.playerProps.list);
            this.index = Number(storedData) || 0;
        }

        console.log(this.props)
        this.props.playerProps.index = this.props.playerProps.index || 0;
        this.playerID = this.generateRandomId();
        let wrapElement = document.createElement('div');
        wrapElement.id = this.playerID;
        wrapElement.style.display = 'none';
        this.appendChild(wrapElement);
        if (this.props.playerProps.listType === 'playlist') {
            this.player = new YT.Player(wrapElement.id, {
                height: '390',
                width: '640',
                playerVars: {
                    listType: 'playlist',
                    list: this.props.playerProps.list,
                    origin: this.props.playerProps.origin || "",
                    widget_referrer: this.props.playerProps.widget_referrer || "",
                    index: this.index,
                    enablejsapi: 1,
                },
                events: {
                    'onReady': this.onTestPlayerReady.bind(this),
                    'onStateChange': this.onTestPlayerStateChange.bind(this),
                    'onError': this.onErrorCase.bind(this)
                }
            });
        } else {
            this.player = new YT.Player(wrapElement.id, {
                height: '390',
                width: '640',
                videoId: 'M7lc1UVf-VE',
                events: {
                    'onReady': this.onTestPlayerReady.bind(this),
                    'onStateChange': this.onTestPlayerStateChange.bind(this),
                    'onError': this.onErrorCase.bind(this)
                }
            });
        }
        

    }
    onTestPlayerReady(event) {
        //console.log(event.target);
        let player = event.target;
        let playerProps = this.props.playerProps;
        if (playerProps.listType === 'playlist') {
            const playlistConfig = {
                listType: 'playlist',
                list: playerProps.list,
                index: this.index
            };
            player.cuePlaylist(playlistConfig);
            console.log('onTestPlayerReady', player);
        } else if (playerProps.listType === 'user_uploads') {
            let playlist = playerProps.video_ids.replace(/ /g, '').split(','),
                index = playerProps.index || 0,
                startSeconds = playerProps.startSeconds || 0;
            player.cuePlaylist(playlist, index, startSeconds);

        }

    }
    onTestPlayerStateChange(event) {
        console.log('onTestPlayerStateChange', event)
        if (event.data === 5 && !this.props.data) { //cued
            if (this.error){
                sessionStorage.setItem(this.props.playerProps.list, this.index-2);
            }
            console.log("cued && no data");
            this.props.data = event.target.getPlaylist();
            if (this.props.playerProps.shuffle) {
                for (let i = this.props.data.length - 1; i >= 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [this.props.data[i], this.props.data[j]] = [this.props.data[j], this.props.data[i]];
                }
            }
            //console.log("DATA - ", this.props.data);
            //window.testme = event.target;
            this.init_structure();
        }
    }
    onErrorCase(e) {
        console.log('slider error', e);
        if (e.data == 150 && e.target.options.playerVars.listType == "playlist") {
            if (this.index < 20) {
                this.index +=1; 
                this.get_videos();
                this.error = true;
            }
        }
    }
    init_structure() {
        this.props.splideID = this.splideID;
        while (this.shadowRoot.firstChild) {
            this.shadowRoot.removeChild(this.shadowRoot.firstChild);
        }
        //assemble
        let elements = assemble(this.props);
        this.shadowRoot.appendChild(elements.css);
        this.shadowRoot.appendChild(elements.html);
        this.style.overflow = 'hidden';
        //run Splide
        this.run_Splide();
        //this.run_youtube()
    }
    run_Splide() {
        if (this.splide) {
            this.splide.destroy();
        }
        let playerProps = this.props.playerProps;
        let SLIDER_PROPS = this.props.sliderProps;
        let options;
        let extentions = {};
        if (SLIDER_PROPS.responsiveBehavior === "item") {
            options = {
                autoWidth: true
            }

            //set item width css
        } else if (SLIDER_PROPS.responsiveBehavior === "fixed") {
            extentions.Grid = Grid;
            options = {
                perPage: SLIDER_PROPS.numberOfColumns,
                grid: {
                    rows: SLIDER_PROPS.numberOfRows,
                    cols: 1,
                    gap: {
                        row: SLIDER_PROPS.gap + 'px',
                        col: SLIDER_PROPS.gap + 'px',
                    },
                },
            }
        }
        options.gap = SLIDER_PROPS.gap + 'px';
        options.focus = 'center'; //test this
        //options.padding = SLIDER_PROPS.padding + 'px';
        options.perMove = SLIDER_PROPS.perMove;
        options.drag = SLIDER_PROPS.drag === "free" ? "free" : JSON.parse(SLIDER_PROPS.drag); //boolean or string
        if (SLIDER_PROPS.loop) options.type = "loop";
        options.paginationKeyboard = SLIDER_PROPS.keyboard ? true : false;
        if (SLIDER_PROPS.moveMode === "autoplay") {
            options.autoplay = true;
            options.pauseOnHover = SLIDER_PROPS.pause;
        } else if (SLIDER_PROPS.moveMode === "autoscroll") {
            extentions.AutoScroll = AutoScroll;
            options.autoScroll = {
                speed: SLIDER_PROPS.scrollSpeed / this.props.data.length / 10,
            }
            // extentions.AutoScroll = AutoScroll;

            // // Define a constant base speed value for consistent scrolling (adjust this value as needed)
            // const baseSpeed = SLIDER_PROPS.scrollSpeed; // This could be a fixed number or user-defined value

            // // Normalize the speed to ensure it doesn't change too drastically based on the number of slides
            // const normalizedSpeed = baseSpeed / Math.max(this.props.data.length, 1); // Prevent division by zero

            // // Set the speed in the autoScroll options
            // options.autoScroll = {
            //     speed: normalizedSpeed,
            // };
        }
        options.video = {
            autoplay: playerProps.autoplay === 1 ? true : false,
            mute: playerProps.volume === 0 ? true : false,
            loop: playerProps.loop ? true : false,
            volume: playerProps.volume,
            playerOptions: {
                youtube: {
                    cc_lang_pref: playerProps.cc_lang_pref !== "null" ? playerProps.cc_lang_pref : null,
                    cc_load_policy: playerProps.cc_load_policy || 0,
                    color: playerProps.color || 'red',
                    controls: playerProps.controls || 1,
                    disablekb: playerProps.disablekb || 0,
                    enablejsapi: playerProps.enablejsapi || 1,
                    fs: playerProps.fs || 1,
                    hl: playerProps.hl !== "null" ? playerProps.hl : null,
                    iv_load_policy: playerProps.iv_load_policy || 1,
                    modestbranding: playerProps.modestbranding || 0,
                    origin: playerProps.origin || window.location.origin,
                    playsinline: playerProps.playsinline || 1,
                    rel: playerProps.rel || 0,
                    widget_referrer: playerProps.widget_referrer || null
                }
            }
        }

        extentions.Video = Video;
        this.splide = new Splide(this.shadowRoot.querySelector("#" + this.props.splideID), options);
        let bar = this.shadowRoot.querySelector('.my-carousel-progress-bar');
        if (SLIDER_PROPS.pagination === "progress") {
            // Updates the bar width whenever the carousel moves:
            this.splide.on('mounted move', () => {
                //console.log('mounted move')
                // var end = this.splide.Components.Controller.getEnd() + 1;
                // var rate = Math.min((this.splide.index + 1) / end, 1);
                // bar.style.width = String(100 * rate) + '%';
            });
        }
        this.splide.on('video:error', (e) => {
            console.log('video:error', e)
            let videoWrapper = e.slide.querySelector('.splide__video__wrapper');
            videoWrapper.style.display = 'block';
            videoWrapper.style.height = '5%';
            videoWrapper.style['min-height'] = '100px';
            videoWrapper.style.bottom = '0';
            videoWrapper.style.position = 'absolute';
            e.slide.querySelector('.splide__video__play').style.display = 'none';
        });
        this.splide.on('active', (slide) => {
            //console.log('ACTIVE SLIDE', slide)
            if (bar) {
                var end = this.splide.Components.Controller.getEnd() + 1;
                var rate = Math.min((this.splide.index + 1) / end, 1);
                bar.style.width = String(100 * rate) + '%';
            }
        });
        this.splide.mount(extentions);
        setTimeout(() => {
            if(this.splide?.Splide?.Components?.Video){
                this.splide.Splide.Components.Video.mount()
            }
            console.log('try mount');
        }, 500);
    }
    onErrorCaseSplide(e) {
        console.log('splide youtube error', e);
        if (e.data == 2) {
            //this.children[0].src = e.target.playerInfo.videoUrl.replace(/watch/g,"embed");
        }
    }
    run_youtube() {
        let playerProps = this.props.playerProps;
        this.props.data.forEach((item) => {
            const playerConfig = {
                height: this.clientHeight,
                width: this.clientWidth,
                playerVars: {
                    //autoplay: this.props.autoplay || 0,
                    videoId: item,
                    cc_lang_pref: playerProps.cc_lang_pref !== "null" ? playerProps.cc_lang_pref : null,
                    cc_load_policy: playerProps.cc_load_policy || 0,
                    color: playerProps.color || 'red',
                    controls: playerProps.controls || 1,
                    disablekb: playerProps.disablekb || 0,
                    enablejsapi: playerProps.enablejsapi || 1,
                    fs: playerProps.fs || 1,
                    hl: playerProps.hl !== "null" ? playerProps.hl : null,
                    iv_load_policy: playerProps.iv_load_policy || 1,
                    modestbranding: playerProps.modestbranding || 0,
                    origin: playerProps.origin || window.location.origin,
                    playsinline: playerProps.playsinline || 1,
                    rel: playerProps.rel || 0,
                    widget_referrer: playerProps.widget_referrer || null,
                },
                events: {
                    'onReady': this.onPlayerReady.bind(this),
                    'onAutoplayBlocked': this.onAutoplayBlocked.bind(this),
                    'onError': this.onErrorCaseEach.bind(this)
                }
            };

            // Initialize player
            let el = this.shadowRoot.querySelector('#id-' + item);
            this.player = new YT.Player(el, playerConfig);
        })
    }
    onErrorCaseEach(e) {
        console.log('individual error', e);
        if (e.data == 2) {
            //this.children[0].src = e.target.playerInfo.videoUrl.replace(/watch/g,"embed");
        }
    }
    onPlayerReady(event) {
        if (this.props.playerProps.autoplay === 1) {
            event.target.setVolume(this.props.playerProps.volume);
            event.target.playVideo();
        }
    }
    onAutoplayBlocked(event) {
        // console.log('AutoplayBlocked:', event);
        if (this.props.playerProps.autoplay === 1) {
            console.log('Autoplay With Sound Blocked By Browser');
            event.target.mute();
            this.player.playVideo();
        }
    }

    static get observedAttributes() {
        return ['settings'];
    }
}

customElements.define('youtube-slider-player', YoutubePlayerSlider);